import type { CSSProperties, ReactNode } from 'react'

export type CalendarKeySidebarItem = {
  label: string
  gradient: string
}

type CalendarKeySidebarProps = {
  showKey: boolean
  primaryItems: CalendarKeySidebarItem[]
  thirdPartyItems: CalendarKeySidebarItem[]
  agenda: ReactNode
  upcoming: ReactNode
  onShowKey: () => void
  onHideKey: () => void
}

function CalendarKeySidebar({
  showKey,
  primaryItems,
  thirdPartyItems,
  agenda,
  upcoming,
  onShowKey,
  onHideKey,
}: CalendarKeySidebarProps) {
  return (
    <aside className={`calendar-key-wrap ${showKey ? 'open' : 'closed'}`}>
      <button
        type="button"
        className="calendar-key-toggle"
        aria-label="Show event types"
        onClick={onShowKey}
        disabled={showKey}
        aria-hidden={showKey}
      >
        Key
      </button>
      <div className="calendar-key">
        <div className="calendar-key-title-row">
          <div className="calendar-key-title">Event types</div>
          <button
            type="button"
            className="calendar-key-minus"
            aria-label="Hide event types"
            onClick={onHideKey}
          >
            –
          </button>
        </div>
        <div className="calendar-key-list">
          {primaryItems.map((item) => (
            <div key={item.label} className="calendar-key-item">
              <span className="calendar-key-label">{item.label}</span>
              <span
                className="calendar-key-dot"
                style={{ ['--key-gradient' as string]: item.gradient } as CSSProperties}
              />
            </div>
          ))}
        </div>
        {thirdPartyItems.length ? (
          <div className="calendar-key-thirdparty">
            <div className="calendar-key-subtitle">Third party</div>
            <div className="calendar-key-list">
              {thirdPartyItems.map((item) => (
                <div key={item.label} className="calendar-key-item">
                  <span className="calendar-key-label">{item.label}</span>
                  <span
                    className="calendar-key-dot"
                    style={{ ['--key-gradient' as string]: item.gradient } as CSSProperties}
                  />
                </div>
              ))}
            </div>
          </div>
        ) : null}
        {agenda}
        {upcoming}
      </div>
    </aside>
  )
}

export default CalendarKeySidebar
